module.exports = __webpack_public_path__ + "src/assets/img/car_color.8cda7dcf.svg";